import { makeStyles } from '@rbx/ui';

const useNotificationThumbnailStyles = makeStyles()(() => ({
  m2Thumbnail: {
    width: 48,
    height: 48,
  },
  m1Thumbnail: {
    width: 24,
    height: 24,
  },
}));

export default useNotificationThumbnailStyles;
